import { Card } from 'react-bootstrap';
import PropertyTableD2WPicker from './components/PropertyTableD2WPicker';
import BaseFeature from './BaseFeature';
import { DIM_TO_WARM } from '../../../../../../utils/constantFeatures';

export default class DimToWarm extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            //isEnabled: this.props.properties[DIM_TO_WARM.enable].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);
    }

    render() {

        const colorTemperature0 = this.props.properties[DIM_TO_WARM.colorTemperature0];
        const colorTemperature1 = this.props.properties[DIM_TO_WARM.colorTemperature1];
        const colorTemperature2 = this.props.properties[DIM_TO_WARM.colorTemperature2];
        const colorTemperature3 = this.props.properties[DIM_TO_WARM.colorTemperature3];
        const level0 = this.props.properties[DIM_TO_WARM.level0];
        const level1 = this.props.properties[DIM_TO_WARM.level1];
        const level2 = this.props.properties[DIM_TO_WARM.level2];
        const level3 = this.props.properties[DIM_TO_WARM.level3];
        return (
            <>
                <div>
                    <Card className={this.getClassName([colorTemperature0, colorTemperature1, colorTemperature2, colorTemperature3, level0, level1, level2, level3])}>
                        <div className="card-header-feature">
                            {'Settings'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyTableD2WPicker
                                properties={this.props.properties}
                                handleChange={this.handleChange}
                                sizeTitle={3}
                                sizePickers={2}
                                sizeMeasureUnit={1}
                                firstRow={{ 'title': 'Color Temperature', 'property': 'dw.c', 'measureUnit': 'K' }}
                                secondRow={{ 'title': 'Dimming Level', 'property': 'dw.l', 'measureUnit': '%' }} />
                        </Card.Body>
                    </Card>
                </div>
                <div>
                    Color temperature values with respect to physical warmest/coldest temperature.<br/>
                    Note: Programming D2W mode with DALI interface will not update physical warmest/coldest settings.
                </div>
            </>
        );
    }
}
